import { render, staticRenderFns } from "./ImportZone.vue?vue&type=template&id=45df44cb&scoped=true"
import script from "./ImportZone.vue?vue&type=script&lang=js"
export * from "./ImportZone.vue?vue&type=script&lang=js"
import style0 from "./ImportZone.vue?vue&type=style&index=0&id=45df44cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df44cb",
  null
  
)

export default component.exports